var _rect, _polygon, _circle, _text, _circle2, _text2, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 167.2 249.4",
    enableBackground: "new 0 0 167.2 249.4",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -5.7,
    y: -5.7,
    fill: "#F9A02E",
    width: 178.6,
    height: 260.8
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#CD6F28",
    points: "-5.4,124.3 9.8,111.9 15.1,123.2 27.8,94.5 47.3,122.5 61.5,110.8 69.7,122.2 82.4,97 96.2,117.2  103,104.1 117.8,124.6 132,83.5 137.3,108.7 144.4,104.1 155.4,134.9 173.2,112.2 173.2,255.3 -5.4,255.3 "
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#BA3033",
    cx: 20.8,
    cy: 39.2,
    r: 2.6
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 11.8434 29.7172)",
    fill: "#220E0A",
    fontFamily: "'RobotoSlab-Regular'",
    fontSize: 20
  }, "\xBF?")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#BA3033",
    cx: 146.4,
    cy: 210.3,
    r: 2.6
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(-1 0 0 -1 155.4042 219.7293)",
    fill: "#220E0A",
    fontFamily: "'RobotoSlab-Regular'",
    fontSize: 20
  }, "\xBF?")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#220E0A",
    points: "93.3,106.2 96.1,107.9 92.9,107.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#220E0A",
    points: "86.8,118.6 89.5,120.4 86.3,119.9  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#220E0A",
    d: "M65.2,98.6l1.7,33.9l8.1,2.3c0,0,1.8-7.3,3.7-11.1c2-4,7.3-3.6,8.1-3.7l0.5-1c-2.3-3.4-1.3-8.1,2.1-10.3 c1.1-0.8,2.4-1.2,3.7-1.2l0.5-1.1c-0.4-0.4-0.8-0.9-1.2-1.5c-2.9-4.4-1.7-10.3,2.7-13.2c1.1-0.7,3.3-1.6,5-2.2l-0.1-0.3L65.2,98.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#220E0A",
    d: "M100,89.1l0.1,0.3c1.4-0.5,2.5-0.9,2.5-0.9L100,89.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#220E0A",
    points: "51.3,108.2 47.3,108 50.1,109.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#220E0A",
    points: "54.1,106.1 50.1,105.9 52.9,107.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#220E0A",
    points: "56.6,104.5 52.6,104.3 55.4,105.9  "
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#220E0A",
    points: "75.3,176.4 75.5,192.8 77.3,192.8 84.5,178.9  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#220E0A",
    d: "M77.2,192.9c0,0-0.4-1.2-0.9-1.5c-1.9-1.1-4.3-0.6-5.4,1.3c-0.1,0.2-0.2,0.4-0.3,0.6c0.8-0.5,1.7-0.9,2.7-1 c-0.6,0.3-1.2,0.8-1.5,1.4c-0.1,0.2-0.2,0.4-0.3,0.6c0.9-0.6,2-0.9,3.1-1.1c-0.7,0.3-1.3,0.8-1.7,1.5c-0.1,0.2-0.2,0.4-0.3,0.6 C74.6,194,77.2,192.9,77.2,192.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#220E0A",
    points: "35.9,159.8 36.4,189.2 39.5,189.2 52.6,164.3  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#220E0A",
    d: "M39.4,189.4c0,0-0.7-2.2-1.6-2.8c-3.3-2.1-7.7-1-9.8,2.3c-0.2,0.3-0.4,0.7-0.5,1c1.5-0.9,3.1-1.5,4.8-1.9 c-1.1,0.6-2.1,1.4-2.8,2.6c-0.2,0.3-0.4,0.7-0.5,1c1.7-1,3.6-1.7,5.5-2c-1.2,0.6-2.3,1.5-3.1,2.7c-0.2,0.3-0.4,0.7-0.5,1 C34.7,191.3,39.4,189.4,39.4,189.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#220E0A",
    points: "119.4,219.4 119.1,223.4 117.9,220.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#220E0A",
    points: "121.9,217 121.6,220.9 120.4,217.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#220E0A",
    points: "123.9,214.7 123.5,218.7 122.4,215.7  "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#220E0A",
    d: "M86.3,39.2c-1.2,3.6-2.5,6.6-4.8,9.7c-5.1,6.5-12.4,12.2-15.1,20.6c1.3,0.7,3,1.6,4.2,2.3 c2.6-9,7.9-14.4,12.2-22.5C84.3,46.4,85.8,42.2,86.3,39.2L86.3,39.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#912221",
    d: "M73.7,142.1c0-20.4,8.4-39.6,10.8-47.8c2-6.9,3.7-19.8-0.3-24.9C80.1,64.3,53.8,79,56.6,79 c0,0,10.6,0.7,10.6,8.5s-7.5,13.5-11.9,17.4c-4,3.5-26.7,18.9-26.7,36.6c0,52.9,89.8,44.1,89.8,67.4c0,13.3-20.1,18.1-20.1,18.1 s28.3-1.5,28.3-20.7C126.4,177,73.7,165.1,73.7,142.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#912221",
    d: "M84.5,69.3c-3.5-5.5-11.4-6.8-17.7-2.9c-3.7,2.3-18.1,14.7-16.6,22.1l10.9-3.9c1.5-0.5,3.2,0.2,3.7,1.7 c0.5,1.5-0.2,3.2-1.7,3.7l-7.6,2.7c7.6,1.2,20.9-4.4,24-6.3C85.7,82.5,88,74.8,84.5,69.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "51.1,88.2 51.1,88.2 52.4,87.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "53.4,87.4 52.4,87.7 51.1,88.2 52.1,91.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "54,90.5 55.2,86.7 52.9,87.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "55.8,89.9 57,86.1 54.7,86.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "57.6,89.2 58.8,85.4 56.5,86.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "59.4,88.6 60.6,84.8 58.3,85.6  "
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7907 0.6122 -0.6122 0.7907 61.8308 -15.7857)",
    fill: "#220E0A",
    cx: 54,
    cy: 82.5,
    rx: 0.7,
    ry: 1.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7907 0.6122 -0.6122 0.7907 62.1268 -18.0147)",
    fill: "#220E0A",
    cx: 57.4,
    cy: 81.9,
    rx: 0.7,
    ry: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#220E0A",
    d: "M98,41.5c-1.2,3.6-2.5,6.6-4.8,9.7c-5.1,6.5-12.4,12.2-15.1,20.6c0.4,0.6,1.2,1.3,1.9,1.7 c0.8,0.4,1.6,0.5,2.4,0.6c2.6-9,7.9-14.4,12.2-22.5C96,48.7,97.5,44.5,98,41.5L98,41.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M66.7,76.4c1.5,0.3,3.2,0,4.6-1c1.4-1,2.3-2.4,2.6-3.9c-1.5-0.3-3.2,0-4.6,1C67.9,73.4,67,74.8,66.7,76.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E37D4C",
    d: "M69.6,74.3c0.4,0.5,1,0.9,1.6,0.9c0.2-0.6,0.1-1.2-0.3-1.8c-0.4-0.5-1-0.9-1.6-0.9 C69.2,73.1,69.3,73.8,69.6,74.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#220E0A",
    d: "M70,73.3c1.6-1,3.5-1.3,5.2-1.1c-1.7-1.4-4.1-1.6-6.1-0.4s-2.9,3.5-2.4,5.6C67.2,75.8,68.4,74.3,70,73.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#220E0A",
    points: "73.2,66.1 77.5,60.7 76.3,66.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#220E0A",
    points: "77.6,66 80.1,62.9 79.4,66  "
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#220E0A",
    cx: 54.7,
    cy: 167.6,
    r: 8.9
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#220E0A",
    points: "45.8,167.6 46.3,197.1 49.4,197.1 62.5,172.1  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#220E0A",
    d: "M49.3,197.2c0,0-0.7-2.2-1.6-2.8c-3.3-2.1-7.7-1-9.8,2.3c-0.2,0.3-0.4,0.7-0.5,1c1.5-0.9,3.1-1.5,4.8-1.9 c-1.1,0.6-2.1,1.4-2.8,2.6c-0.2,0.3-0.4,0.7-0.5,1c1.7-1,3.6-1.7,5.5-2c-1.2,0.6-2.3,1.5-3.1,2.7c-0.2,0.3-0.4,0.7-0.5,1 C44.6,199.1,49.3,197.2,49.3,197.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#220E0A",
    cx: 89.1,
    cy: 182.9,
    r: 5
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#220E0A",
    points: "84.1,182.9 84.4,199.3 86.1,199.3 93.4,185.4  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#220E0A",
    d: "M86.1,199.4c0,0-0.4-1.2-0.9-1.5c-1.9-1.1-4.3-0.6-5.4,1.3c-0.1,0.2-0.2,0.4-0.3,0.6c0.8-0.5,1.7-0.9,2.7-1 c-0.6,0.3-1.2,0.8-1.5,1.4c-0.1,0.2-0.2,0.4-0.3,0.6c0.9-0.6,2-0.9,3.1-1.1c-0.7,0.3-1.3,0.8-1.7,1.5c-0.1,0.2-0.2,0.4-0.3,0.6 C83.4,200.5,86.1,199.4,86.1,199.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#220E0A",
    points: "123.2,157.5 121.8,162.8 121,157.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#220E0A",
    points: "99.8,153.5 98.3,158.7 97.4,153.3  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#912221",
    d: "M117.2,97.3l-50.1,31.2l0.4,14.2c0,0,12.7-0.9,19.7,0.2c7.4,1.1,9.6,9.9,10.2,11.1l1.9,0.3 c4.4-5.4,12.3-6.3,17.7-2c1.8,1.4,3.1,3.3,3.9,5.3l2,0.3c0.5-0.9,1.1-1.8,1.8-2.7c5.6-7,15.7-8.1,22.7-2.5 c1.8,1.4,4.3,4.4,6.2,6.8l0.4-0.3L117.2,97.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#220E0A",
    d: "M154.1,159.3l-0.4,0.3c1.6,2,2.7,3.6,2.7,3.6L154.1,159.3z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#220E0A",
    d: "M145.2,40.8l-6.9-10.7l-9.1,6c0,0,0,0,0,0l5.5-7.9l-8.7-5.9l-0.5-0.4c0,0,0.2,0.2,0.5,0.4 c0.3,0.3,0.7,0.7,0.9,1c0.7,1.1,0.5,2.5-0.6,3.3c-0.1,0.1-0.3,0.2-0.4,0.2v0l-0.7,0.1l0.7,0.2c0.3,0.1,0.5,0.3,0.7,0.6 c0.6,0.8,0.4,2-0.4,2.6l-0.6,0.1l0.7,0.2c0.2,0.1,1.4,0.5,1.5,1.6c0.1,0.6,0,1.6-0.1,2.3c-1.9-2.3-4-4.8-5.2-6.9l-1.4-2.8l-0.5,0.7 l-1-3.8l0.6,4.5l-0.3,0.4l-1-3.7l0.5,4.4l-2.5,3.7l5.3-2.8c0.3,2.7,1.4,5.3,2.7,7.5l-0.4,2.1l0.6,0.6l-0.2-0.8l0.4-1.1 c0.1,0.2,0.3,0.4,0.4,0.6l-0.5,2.3l0.6,0.5l-0.2-0.7l0.6-1.4c0.6,0.9,1.2,1.6,1.7,2.3l-1.5,1.6l1,2.2l-1.3,1.1l2.1-0.8l-0.5-2.4 l1.1-0.7c0.3,0.4,0.6,0.6,0.8,0.9l-1.2,1.6l1.6,2.7l-1.5,1.5l2.5-1.2l-0.9-2.9l0.6-0.5c3.9,3.6,7.6,8,10.3,13.2c0,0-2-9.5-8.6-16.5 c0,0-0.5-0.6-1.4-1.4c0.7,0,1.5-0.1,2.1,0c1.3,0.1,1.8,1.7,1.9,1.9l0.2,0.8l0.2-0.8c0.7-1,2.1-1.2,3.1-0.5c0.3,0.2,0.6,0.6,0.7,0.9 l0.2,0.9l0.2-0.8v0c0.1-0.2,0.2-0.3,0.3-0.5c0.9-1.3,2.7-1.5,4-0.6C144.3,39.9,144.8,40.4,145.2,40.8c0.2,0.4,0.4,0.7,0.4,0.7 L145.2,40.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#220E0A",
    d: "M40.2,65.1l-1.1-2.7l0.9-2.7l-1.1,2.2l-0.1-0.3l1-2.7l-1.2,2.2l-0.2-0.5l-1.3,1.5 c-1,1.1-2.7,2.5-4.2,3.6c0-0.4,0.1-1,0.3-1.4c0.2-0.7,1-0.7,1.2-0.8l0.4,0l-0.4-0.2c-0.4-0.5-0.4-1.2,0.1-1.7 c0.2-0.1,0.3-0.2,0.5-0.3l0.5,0l-0.4-0.2l0,0c-0.1-0.1-0.2-0.1-0.2-0.2c-0.6-0.6-0.5-1.6,0.1-2.1c0.2-0.1,0.5-0.3,0.7-0.5 c0.2-0.1,0.4-0.2,0.4-0.2l-0.4,0.2L29.4,61l2.4,5.7c0,0,0,0,0,0l-4.9-5l-5.8,5.7l-0.4,0.4c0,0,0.2-0.1,0.4-0.3 c0.3-0.2,0.6-0.5,0.9-0.6c0.9-0.4,2,0,2.4,0.9c0.1,0.1,0.1,0.2,0.1,0.3l0,0.5l0.2-0.5c0.1-0.2,0.3-0.4,0.6-0.5 c0.7-0.3,1.6,0,1.9,0.7l0,0.5l0.2-0.5c0.1-0.1,0.6-1,1.4-0.9c0.4,0,0.9,0.2,1.3,0.3c-0.6,0.4-1.1,0.7-1.1,0.7 c-5.1,3.5-7.6,9.2-7.6,9.2c2.4-2.9,5.3-5.1,8.3-6.9l0.3,0.4l-1,1.7l1.4,1.1l-0.7-1.1l1.3-1.5l-0.5-1.1c0.2-0.1,0.4-0.2,0.6-0.4 l0.6,0.6l-0.6,1.4l1.2,0.8l-0.7-0.8l0.9-1.3L32,69.3c0.4-0.3,0.9-0.7,1.4-1.2l0.2,1l-0.2,0.4l0.4-0.2l0-1.5c0.1-0.1,0.2-0.2,0.3-0.3 l0.1,0.8L34,68.6l0.5-0.3l0-1.3c1.1-1.2,2.2-2.7,2.7-4.3L40.2,65.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragons);
export default __webpack_public_path__ + "static/media/dragons.8e45b71634df4e0534b8d9296b16f62f.svg";
export { ForwardRef as ReactComponent };